module.exports = __webpack_public_path__ + "static/media/video-plus.d69d5402.svg";